import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { useDispatch, useSelector } from 'react-redux';
import { notificationsAction } from '../../actions/notificationsAction';
import AvatarItem from './AvatarItem';
import NotificationContent from './NotificationContent';
import { useNavigate } from 'react-router-dom';

function NotificationList(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const notificationList = useSelector((state) => state.notificationState.notifications);

    
    const handleCloseNavMenuNotification = () => {
        props.closeNotification()
    };
    const goToNotification = (item) => {
        let action = JSON.parse(item.action);
        let link= action.find(i=>i.link);
        if(link.link)
        {
            navigate(process.env.PUBLIC_URL+link.link);
            navigate(0)
        }
        
    };
  return (
    <>
        <div className='notification_head_close'>
            <Typography component="h2" variant="h2">Notifications <IconButton size="small" onClick={handleCloseNavMenuNotification} color="inherit"><CloseIcon/></IconButton></Typography>
        </div>
        {notificationList.length>0 &&
        <List className='notificationList' sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {notificationList.map(items=>
            <ListItem alignItems="flex-start" onClick={()=>goToNotification(items)}>
                <ListItemAvatar><AvatarItem item={items} /></ListItemAvatar>
                <NotificationContent item={items} />
            </ListItem>
        )}
        </List>
        }
    </>
  )
}

export default NotificationList